var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgVPrint = function (_a) {
    var title = _a.title, titleId = _a.titleId, desc = _a.desc, descId = _a.descId, props = __rest(_a, ["title", "titleId", "desc", "descId"]);
    return (_jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId }, props, { children: [desc ? _jsx("desc", __assign({ id: descId }, { children: desc })) : null, title ? _jsx("title", __assign({ id: titleId }, { children: title })) : null, _jsx("path", { d: "M20 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM4 16a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z", fill: "currentColor" }), _jsx("path", { d: "M19 4a2 2 0 0 0-2-2H9.45a1 1 0 0 0-.748.336l-.113.127a2 2 0 0 0-.182.171L5.54 5.701a2 2 0 0 0-.44.747A1 1 0 0 0 5 6.88V11H4a4 4 0 0 0-4 4v5a2 2 0 0 0 2 2 1 1 0 0 0 1 1h2a1 1 0 0 0 1-1h12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1 2 2 0 0 0 2-2v-5a4 4 0 0 0-4-4h-1V4Zm-2 7H7V9h3a2 2 0 0 0 2-2V4h5v7ZM4 13h16a2 2 0 0 1 2 2v5H2v-5a2 2 0 0 1 2-2Zm5.898-9H10v3H7.231l2.667-3Z", fill: "currentColor" })] })));
};
export default SvgVPrint;
